/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Addb2b,
  getClaimTag,
  getOrganizationDataWithoutPagination,
  submitClaimTag,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import axios from "axios";
import Select from "react-select";

class addb2b extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_name: "",
      company_nameError: null,
      discount: "",
      discountError: null,
      delivery_value: "",
      delivery_valueError: null,
      note: "",
      noteError: null,
      alert: null,
      _notificationSystem: null,
      cardHidden: true,
      br_number: "",
      br_numberError: null,
      payment_method: "0",
      type: "0",
      payment_methodError: null,
      cpcode: "+94",
      address_line_1: "",
      address_line_1Error: null,
      errormessages: [],
      oldCompanyLogofile: "",
      company_logo: "",
      company_logo_data: "",
      contactdetiallist: [],
      deleted_contact: [],
      organizationOptions: [],
      parentOrganizationID: "",
      credit_period: "",
      credit_periodError: null,
      is_claimable: false,
      tags: [],
      getB2bTags: [],
      poolValue: null,
      industryTagError: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handlesubmit = this.handlesubmit.bind(this);
    this.code_error = React.createRef();
    this.handlecompany_logoFileChange =
      this.handlecompany_logoFileChange.bind(this);
  }

  handlecompany_logoFileChange(event) {
    this.setState({ company_logo: event.target.files[0] });
  }

  uploadcompany_logo() {
    document.getElementById("selectcompany_logo").click();
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>B2B</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });

    setTimeout(() => {
      this.props.history.push("/admin/viewb2b");
    }, 3000);
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    getOrganizationDataWithoutPagination(obj).then((cdata) => {
      const companyData = cdata.data;
      const organizationOptions = companyData.map((data) => {
        return {
          value: data.id,
          label: data.company_name,
        };
      });
      this.setState({ organizationOptions: organizationOptions });

      // this.setState({
      //   companyList: companyData,
      // });
    });
    getClaimTag(obj).then((res) => {
      const options = res.data.data.map((item) => ({
        label: item.keyword,
        value: item.id,
      }));
      this.setState({ getB2bTags: options });
    });
  }

  async handlesubmit(e) {
    const notification = this.state._notificationSystem.current;
    this.setState({ errormessages: [] });
    let error = false;
    let company_nameErr = "";
    let creditPeriodError = "";
    let industryTagError = "";

    if (this.state.company_name.length === 0) {
      error = true;
      company_nameErr = (
        <small className="text-danger">Company Name is required.</small>
      );
    }
    if (!this.state.tags || this.state.tags.length === 0) {
      error = true;
      industryTagError = (
        <small className="text-danger">Industry is required.</small>
      );
    }
    if (this.state.credit_period === "" || this.state.credit_period === null) {
      error = true;
      creditPeriodError = (
        <small className="text-danger">Credit Period is required.</small>
      );
    }

    const contact_list_old = [...this.state.contactdetiallist];
    const errormessages = [];
    let Procurement = false;
    let Finance = false;

    if (contact_list_old.length === 0) {
      error = true;
      errormessages.push(
        "Please add procurement and finance contacts person detail."
      );
    } else {
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      for (let i = 0; i < contact_list_old.length; i++) {
        if (contact_list_old[i].name === "") {
          error = true;
          contact_list_old[i].cperson_name_Error = (
            <small className="text-danger">Please enter name</small>
          );
        }

        if (contact_list_old[i].email !== "") {
          if (!emailReg.test(contact_list_old[i].email)) {
            error = true;
            contact_list_old[i].cperson_email_Error = (
              <small className="text-danger">
                Please enter valid email address
              </small>
            );
          }
        }

        if (contact_list_old[i].mobile_no === "") {
          error = true;
          contact_list_old[i].cperson_mobile_Error = (
            <small className="text-danger">Please enter mobile number</small>
          );
        }

        if (contact_list_old[i].user_type === "") {
          error = true;
          contact_list_old[i].user_type_Error = (
            <small className="text-danger">Please select user type</small>
          );
        } else {
          if (contact_list_old[i].user_type === "1") {
            Procurement = true;
          }
          if (contact_list_old[i].user_type === "2") {
            Finance = true;
          }
        }
      }

      if (!Procurement) {
        error = true;
        errormessages.push("Please add 'Procurement' contact details.");
      }
      if (!Finance) {
        error = true;
        errormessages.push("Please add 'finance' contact details.");
      }
    }

    if (error) {
      this.setState({
        company_nameError: company_nameErr,
        contactdetiallist: contact_list_old,
        errormessages: errormessages,
        credit_periodError: creditPeriodError,
        industryTagError: industryTagError,
      });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.createb2c(1, contact_list_old)}
            onCancel={() => this.createb2c(0, contact_list_old)}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="No"
            showCancel
          >
            Do you want to create this organization in B2C and link this
            organization?
          </SweetAlert>
        ),
      });
    }
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  onParentOrganizationChange = (value) => {
    this.parentOrganizationID = value;
  };

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleAddClick = () => {
    this.setState({
      contactdetiallist: [
        ...this.state.contactdetiallist,
        {
          name: "",
          email: "",
          mobile_no: "",
          user_type: "",
          b2b_id: "0",
          ccode: "+94",
          cperson_name_Error: "",
          cperson_email_Error: "",
          user_type_Error: "",
          cperson_mobile_Error: "",
        },
      ],
      errormessages: [],
    });
  };

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.contactdetiallist];
    if (name == "name") {
      list[index][name] = value;
      list[index]["cperson_name_Error"] = "";
      this.setState({ contactdetiallist: list });
    }

    if (name == "email") {
      list[index][name] = value;
      list[index]["cperson_email_Error"] = "";
      this.setState({ contactdetiallist: list });
    }

    if (name == "mobile_no") {
      const re = /^[0-9]*$/;
      if (re.test(value) == true && value.length <= 10) {
        list[index][name] = value;
      }

      list[index]["cperson_mobile_Error"] = "";
      this.setState({ contactdetiallist: list });
    }

    if (name == "user_type") {
      list[index][name] = value;
      list[index]["user_type_Error"] = "";
      this.setState({ contactdetiallist: list });
    }

    if (name == "ccode") {
      list[index][name] = value;
      this.setState({ contactdetiallist: list });
    }
  };

  handleCancelClick = (e, index) => {
    var data = this.state.contactdetiallist;
    data.splice(index, 1);
    this.setState({
      contactdetiallist: data,
    });
  };

  createb2c = async (type, contact_list_old) => {
    this.setState({ alert: null });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (this.state.company_logo.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();
      fdata.append("company_logo", this.state.company_logo);
      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/comapany/logo";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          this.setState({
            company_logo_data: res.data.data.company_logo_url,
          });
        });
    } else {
      this.setState({ company_logo_data: this.state.oldCompanyLogofile });
    }

    var newContact_list = [];
    for (let i = 0; i < contact_list_old.length; i++) {
      var details_in = {
        id: contact_list_old[i].b2b_id,
        name: contact_list_old[i].name,
        email: contact_list_old[i].email,
        mobile_no: contact_list_old[i].ccode + contact_list_old[i].mobile_no,
        user_type:
          contact_list_old[i].user_type == 1 ? "Procurement" : "Finance",
      };
      newContact_list.push(details_in);
    }

    Addb2b(
      this.state.company_name,
      this.state.discount,
      this.state.delivery_value,
      this.state.note,
      this.state.br_number,
      this.state.payment_method,
      this.state.type,
      this.state.address_line_1,
      this.state.company_logo_data,
      newContact_list,
      this.state.deleted_contact,
      type,
      this.parentOrganizationID,
      this.state.credit_period,
      this.state.is_claimable,
      this.state.poolValue,
      obj
    )
      .then(async (res) => {
        // const createdId = res.data.data.id;
        // this.handleSubmitTags(createdId);
        if (res.data.success === false) {
          if (res.data.data.length != 0) {
            var ermessage = [];
            for (var key of Object.keys(res.data.data)) {
              var data = res.data.data[key];
              ermessage.push(data);
            }
            this.code_error.current.focus();
            this.setState({ errormessages: ermessage });
          } else {
            this.handleClick("bl");
          }
        } else if (res.data.success === true) {
          const createdId = res.data.data.id;
          this.handleSubmitTags(createdId);
          this.handleSuccess("bl");
          this.setState({
            company_name: "",
            discount: "",
            delivery_value: "",
            note: "",
            br_number: "",
            payment_method: "0",
            type: "0",
            address_line_1: "",
            credit_period: "",
          });
          // this.props.history.push('/admin/viewb2b');
        }
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  };
  handleCheckBoxClick = (e) => {
    this.setState({ is_claimable: e.target.checked });
  };
  handleSubmitTags = async (createdId) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const tagPayload = {
      order_id: createdId,
      tag_id: this.state.tags.map((t) => t.value),
      type: "b2b",
    };
    await submitClaimTag(obj, tagPayload);
  };

  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.code_error}
        />
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <ControlLabel> Company name</ControlLabel>
                      <FormControl
                        name="company_name"
                        value={this.state.company_name || ""}
                        onChange={(event) => {
                          this.setState({ company_name: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                company_nameError: (
                                  <small className="text-danger">
                                    Company Name is required.
                                  </small>
                                ),
                              })
                            : this.setState({ company_nameError: null });
                        }}
                        placeholder="Enter Companyname"
                        type="text"
                      />
                      {this.state.company_nameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Discount</ControlLabel>
                      <FormControl
                        name="discount"
                        value={this.state.discount || ""}
                        onChange={(event) => {
                          this.setState({ discount: event.target.value });
                        }}
                        placeholder="Enter Discount"
                        type="number"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Delivery Value</ControlLabel>
                      <FormControl
                        name="delivery_value"
                        value={this.state.delivery_value || ""}
                        onChange={(event) => {
                          this.setState({ delivery_value: event.target.value });
                        }}
                        placeholder="Enter Delivery Value"
                        type="number"
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>BR Number</ControlLabel>
                      <FormControl
                        type="number"
                        name="br_number"
                        className="form-control"
                        value={this.state.br_number || ""}
                        onChange={(event) => {
                          this.setState({ br_number: event.target.value });
                          // event.target.value === ""
                          //   ? this.setState({
                          //     br_numberError: (
                          //         <small className="text-danger">
                          //           BR Number is required.
                          //         </small>
                          //       )
                          //     })
                          //   : this.setState({ br_numberError: null });
                        }}
                        placeholder="Enter BR Number"
                      />
                      {this.state.br_numberError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Address Line 1 </ControlLabel>
                      <FormControl
                        name="address_line_1"
                        value={this.state.address_line_1}
                        onChange={(event) => {
                          this.setState({ address_line_1: event.target.value });
                          // event.target.value === ""
                          //   ? this.setState({
                          //     address_line_1Error: (
                          //         <small className="text-danger">
                          //           Address Line 1 is required.
                          //         </small>
                          //       )
                          //     })
                          //   : this.setState({ address_line_1Error: null });
                        }}
                        placeholder="Enter Address Line 1"
                        type="text"
                      />
                      {this.state.address_line_1Error}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Payment Method</ControlLabel>
                      <select
                        name="payment_method"
                        className="form-control"
                        rows="3"
                        value={this.state.payment_method || ""}
                        onChange={(event) => {
                          this.setState({ payment_method: event.target.value });
                        }}
                      >
                        <option value="0">Select Payment Method</option>
                        <option value="1">Cash</option>
                        <option value="2">Card</option>
                        <option value="3">Cheque</option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Parent Organization</ControlLabel>
                      <Select
                        style={{ textTransform: "capitalize" }}
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="parentOrganization"
                        // value={this.state.subscriberItems.find(obj => obj.value == sub_id)}
                        onChange={(value) =>
                          this.onParentOrganizationChange(value.value)
                        }
                        options={this.state.organizationOptions}
                        placeholder="Parent Organization"
                        noOptionsMessage={() => "Type Name of Organization"}
                      />
                    </FormGroup>
                    {/* <FormGroup>
                      <ControlLabel>Company Type</ControlLabel>
                      <select
                        name="company_type"
                        className="form-control"
                        rows="3"
                        value={this.state.type || ""}
                        onChange={(event) => {
                          this.setState({ type: event.target.value });
                        }}
                      >
                        <option value="0">Genaric</option>
                        <option value="1">Insuarance</option>
                      </select>
                    </FormGroup> */}
                    <FormGroup>
                      <ControlLabel>Industry</ControlLabel>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        isMulti
                        closeMenuOnSelect={false}
                        value={this.state.tags}
                        onChange={(newValue) =>
                          this.setState({
                            tags: newValue,
                            industryTagError: null,
                          })
                        }
                        options={this.state.getB2bTags}
                        placeholder="select Industry"
                        noOptionsMessage={() => "No tags found"}
                        isClearable
                      />
                      {this.state.industryTagError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Credit Period</ControlLabel>
                      <select
                        name="credit_period"
                        className="form-control"
                        value={this.state.credit_period || ""}
                        onChange={(event) => {
                          const value = event.target.value;
                          this.setState({
                            credit_period: value,
                            credit_periodError: null,
                          });
                        }}
                      >
                        <option value="0">Select Credit Period</option>
                        <option value="7 Days">7 Days</option>
                        <option value="14 Days">14 Days</option>
                        <option value="21 Days">21 Days</option>
                        <option value="30 Days">30 Days</option>
                      </select>
                    </FormGroup>
                    {this.state.credit_periodError}
                    {/* <FormGroup>
                      <ControlLabel>Pool Value </ControlLabel>
                      <FormControl
                        name="poolValue"
                        value={this.state.poolValue}
                        onChange={(event) => {
                          this.setState({ poolValue: event.target.value });
                        }}
                        placeholder="Enter Pool Value"
                        type="number"
                      />
                    </FormGroup> */}
                    <FormGroup>
                      <ControlLabel>Pool Value </ControlLabel>
                      <FormControl
                        name="poolValue"
                        value={this.state.poolValue}
                        onChange={(event) => {
                          this.setState({ poolValue: event.target.value });
                        }}
                        placeholder="Enter Pool Value"
                        type="number"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Note</ControlLabel>
                      <textarea
                        name="note"
                        className="form-control"
                        rows="3"
                        value={this.state.note || ""}
                        onChange={(event) => {
                          this.setState({ note: event.target.value });
                        }}
                        placeholder="Enter Note"
                      ></textarea>
                    </FormGroup>

                    <div>
                      {this.state.contactdetiallist.map((x, i) => (
                        <>
                          <h2 className="contacttitle">Contact {i + 1}</h2>
                          <div className="contactdetiallist_heading_b2b">
                            <Row>
                              <Col sm={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Name</ControlLabel>
                                  <FormControl
                                    name="name"
                                    value={x.name}
                                    onChange={(e) =>
                                      this.handleInputChange(e, i)
                                    }
                                    placeholder="Enter Name"
                                    type="text"
                                  />
                                  {x.cperson_name_Error}
                                </FormGroup>
                              </Col>

                              <Col sm={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Email</ControlLabel>
                                  <FormControl
                                    name="email"
                                    value={x.email}
                                    onChange={(e) =>
                                      this.handleInputChange(e, i)
                                    }
                                    placeholder="Enter Email"
                                    type="text"
                                  />
                                  {x.cperson_email_Error}
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Mobile number</ControlLabel>
                                  <div className="phone_input_form">
                                    <select
                                      onChange={(e) =>
                                        this.handleInputChange(e, i)
                                      }
                                      name="ccode"
                                      value={x.ccode}
                                      className="form-control phone_dial_code"
                                    >
                                      <option value="+94">+94</option>
                                      <option value="+91">+91</option>
                                      <option value="+852">+852</option>
                                    </select>
                                    <FormControl
                                      name="mobile_no"
                                      value={x.mobile_no}
                                      onChange={(e) =>
                                        this.handleInputChange(e, i)
                                      }
                                      placeholder="Enter Mobile Number"
                                      type="text"
                                    />
                                  </div>

                                  {x.cperson_mobile_Error}
                                </FormGroup>
                              </Col>

                              <Col sm={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>User type</ControlLabel>
                                  <select
                                    onChange={(e) =>
                                      this.handleInputChange(e, i)
                                    }
                                    name="user_type"
                                    value={x.user_type}
                                    className="form-control"
                                    style={{ marginTop: "0.9rem" }}
                                  >
                                    <option value="">Select User Type</option>
                                    <option value="1">Procurement</option>
                                    <option value="2">Finance</option>
                                  </select>
                                </FormGroup>
                                {x.user_type_Error}
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6} xs={12}>
                                <Button
                                  class="btn btn-color"
                                  fill
                                  onClick={(e) => this.handleCancelClick(e, i)}
                                >
                                  Cancel
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        </>
                      ))}
                      <FormGroup>
                        <Checkbox
                          number="1"
                          checked={this.state.is_claimable}
                          onClick={(e) => this.handleCheckBoxClick(e)}
                          label="Claimable Organization"
                        ></Checkbox>
                      </FormGroup>

                      <Button
                        class="btn-color" //bsStyle="info"
                        fill
                        onClick={this.handleAddClick}
                        className="add_contact_person_btn"
                      >
                        Add Contact Person<i className="fa fa-plus"></i>
                      </Button>
                    </div>

                    <FormGroup>
                      <ControlLabel>Company Logo</ControlLabel>
                      <br></br>

                      <input
                        style={{ display: "none" }}
                        id="selectcompany_logo"
                        type="file"
                        className="form-control"
                        name="company_logo"
                        onChange={this.handlecompany_logoFileChange}
                      />
                      <Button
                        onClick={this.uploadcompany_logo}
                        style={{ color: "#2B3A41" }}
                      >
                        {" "}
                        <i
                          className={
                            this.state.company_logo == ""
                              ? "fa fa-plus"
                              : "fa fa-pencil fa-fw"
                          }
                        ></i>{" "}
                        {this.state.company_logo == ""
                          ? "Choose Company Logo"
                          : "Change Company Logo"}
                      </Button>
                    </FormGroup>

                    <Button
                      onClick={this.handlesubmit.bind(this)}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default addb2b;
